export const Currencies: {
    id: number
    short: string
    title: string
    img: string
    country: string
}[] = [
    {
        id: 1,
        short: 'NOK',
        title: 'Norwegian Krone',
        img: '/assets/img/currency/NOK.svg',
        country: 'Norway',
    },
    {
        id: 2,
        short: 'SEK',
        title: 'Swedish Krona',
        img: '/assets/img/currency/SEK.svg',
        country: 'Sweden',
    },
    {
        id: 3,
        short: 'DKK',
        title: 'Danish Krone',
        img: '/assets/img/currency/DKK.svg',
        country: 'Denmark',
    },
    {
        id: 4,
        short: 'EUR',
        title: 'Euro',
        img: '/assets/img/currency/EUR.svg',
        country: 'Europe',
    },
    {
        id: 5,
        short: 'USD',
        title: 'US Dollar',
        img: '/assets/img/currency/USD.svg',
        country: 'United States',
    },
    {
        id: 6,
        short: 'GBP',
        title: 'British Pound',
        img: '/assets/img/currency/GBP.svg',
        country: 'United Kingdom',
    },
    {
        id: 7,
        short: 'UAH',
        title: 'Ukrainian Hryvnia',
        img: '/assets/img/currency/UAH.svg',
        country: 'Ukraine',
    },
    {
        id: 8,
        short: 'COP',
        title: 'Colombian Peso',
        img: '/assets/img/currency/COP.svg',
        country: 'Colombia',
    },
    {
        id: 9,
        short: 'MYR',
        title: 'Malaysian Ringgit',
        img: '/assets/img/currency/MYR.svg',
        country: 'Malaysia',
    },
    {
        id: 10,
        short: 'MZN',
        title: 'Mozambique Metical',
        img: '/assets/img/currency/MZN.svg',
        country: 'Mozambique',
    },
    {
        id: 11,
        short: 'KRW',
        title: 'South Korean won',
        img: '/assets/img/currency/KRW.svg',
        country: 'South Korea',
    },
    {
        id: 12,
        short: 'SGD',
        title: 'Singapore Dollar',
        img: '/assets/img/currency/SGD.svg',
        country: 'Singapore',
    },
    {
        id: 13,
        short: 'CNY',
        title: 'Chinese Yuan Renminbi',
        img: '/assets/img/currency/CNY.svg',
        country: 'China',
    },
    {
        id: 14,
        short: 'BRL',
        title: 'Brazilian Real',
        img: '/assets/img/currency/BRL.svg',
        country: 'Brazil',
    },
    {
        id: 15,
        short: 'MAD',
        title: 'Malagasy Ariary',
        img: '/assets/img/currency/MAD.svg',
        country: 'Madagascar',
    },
    {
        id: 16,
        short: 'ZAR',
        title: 'South African Rand',
        img: '/assets/img/currency/ZAR.svg',
        country: 'South Africa',
    },
    {
        id: 17,
        short: 'INR',
        title: 'Indian Rupee',
        img: '/assets/img/currency/INR.svg',
        country: 'India',
    },
    {
        id: 18,
        short: 'BGN',
        title: 'Bulgarian Lev',
        img: '/assets/img/currency/BGN.svg',
        country: 'Bulgaria',
    },
    {
        id: 19,
        short: 'CZK',
        title: 'Czech Koruna',
        img: '/assets/img/currency/CZK.svg',
        country: 'Czechia',
    },
    {
        id: 20,
        short: 'HUF',
        title: 'Hungarian forint',
        img: '/assets/img/currency/HUF.svg',
        country: 'Hungary',
    },
    {
        id: 21,
        short: 'PLN',
        title: 'Polish Zloty',
        img: '/assets/img/currency/PLN.svg',
        country: 'Poland',
    },
    {
        id: 22,
        short: 'RON',
        title: 'Romanian leu',
        img: '/assets/img/currency/RON.svg',
        country: 'Romania',
    },
    {
        id: 23,
        short: 'CHF',
        title: 'Swiss Franc',
        img: '/assets/img/currency/CHF.svg',
        country: 'Switzerland',
    },
    {
        id: 24,
        short: 'CAD',
        title: 'Canadian Dollar',
        img: '/assets/img/currency/CAD.svg',
        country: 'Canada',
    },
    {
        id: 25,
        short: 'MXN',
        title: 'Mexican Peso',
        img: '/assets/img/currency/MXN.svg',
        country: 'Mexico',
    },
    {
        id: 26,
        short: 'SAR',
        title: 'Saudi Riyal',
        img: '/assets/img/currency/SAR.svg',
        country: 'Saudi Arabia',
    },
    {
        id: 27,
        short: 'AED',
        title: 'United Arab Emirates Dirham',
        img: '/assets/img/currency/AED.svg',
        country: 'United Arab Emirates',
    },
]

function getCurrencyById(id: number | string | null | undefined) {
    const numericId = typeof id === 'string' ? parseInt(id, 10) : id
    return Currencies.find((currency) => currency.id === numericId)
}

export default getCurrencyById
